export enum RugbyUnionMaulAttribute {
  Won = 2979,
  Lost = 2980,
  LeadToTry = 2981,
}
